import initialState from './initialState';

import set from 'ramda.set';
import lensPath from 'ramda.lenspath';
import view from 'ramda.view';

import {
  prepareETRReport,
  prepareTagsGroups,
} from './helpers';


import {
  SELECT_GROUPTYPE_FOR_ETR,
  SELECT_GROUP_ITEM_FOR_ETR,
  SELECT_GROUPBY_FOR_ETR,
  SELECT_VIEWBY_FOR_ETR,
  FETCHING_SL_GROUP_ITEMS_FOR_ETR,
  FETCHING_SL_GROUP_ITEMS_FOR_ETR_SUCCESS,
  FETCHING_SL_GROUP_ITEMS_FOR_ETR_FAILURE,
  UPDATE_SELECTED_COUNTRY_TAX_TYPES_FOR_ETR,
  UPDATE_STATUTORY_TAX_RATE_FOR_ETR,
  FETCHING_SL_GROUP_TYPES_FOR_ETR,
  FETCHING_SL_GROUP_TYPES_FOR_ETR_SUCCESS,
  FETCHING_SL_GROUP_TYPES_FOR_ETR_FAILURE,
  SAVING_CUSTOM_ETR_DRIVER,
  SAVING_CUSTOM_ETR_DRIVER_SUCCESS,
  SAVING_CUSTOM_ETR_DRIVER_FAILURE,
  FETCHING_COUNTRY_TAX_TYPES_AND_RATES,
  FETCHING_COUNTRY_TAX_TYPES_AND_RATES_SUCCESS,
  FETCHING_COUNTRY_TAX_TYPES_AND_RATES_FAILURE,
  RESET_COUNTRY_TAX_TYPES_AND_RATES,
  FETCHING_ETR_REPORT_DATA,
  FETCHING_ETR_REPORT_DATA_SUCCESS,
  FETCHING_ETR_REPORT_DATA_FAILURE,
  RESET_ETR_REPORT,
  ETR_TOGGLE_VISIBILITY,
  SELECT_EFFECTIVE_TAX_RATE_CELL_FOR_DETAILS,
  FETCHING_COUNTRY_TAX_TYPES_FOR_COMPANY_CODE_SUCCESS,
  RESET_COUNTRY_TAX_TYPES_FOR_COMPANY_CODE,
} from './types';

import { LOGOUT_SUCCESS } from '../../../userData/store/types';

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOGOUT_SUCCESS:
      return {
        ...initialState,
      };

    case SELECT_GROUPTYPE_FOR_ETR:
      return {
        ...state,
        groupType: action.groupType,
      };

    case SELECT_GROUP_ITEM_FOR_ETR:
      return {
        ...state,
        groupItem: action.groupItem,
      };

    case SELECT_GROUPBY_FOR_ETR:
      return {
        ...state,
        groupBy: action.groupBy,
      };

    case SELECT_VIEWBY_FOR_ETR:
      return {
        ...state,
        viewBy: action.viewBy,
      };

    case FETCHING_SL_GROUP_ITEMS_FOR_ETR:
      return {
        ...state,
        isFetchingGroupItems: true,
      };

    case FETCHING_SL_GROUP_ITEMS_FOR_ETR_SUCCESS:
      return {
        ...state,
        isFetchingGroupItems: false,
        groupItems: action.groupItems,
      };

    case FETCHING_SL_GROUP_ITEMS_FOR_ETR_FAILURE:
      return {
        ...state,
        isFetchingGroupItems: false,
      };

    case UPDATE_SELECTED_COUNTRY_TAX_TYPES_FOR_ETR:
      return {
        ...state,
        selectedCountryTaxTypes: action.countryTaxTypes,
      };

    case UPDATE_STATUTORY_TAX_RATE_FOR_ETR:
      return {
        ...state,
        statutoryTaxRate: action.statutoryTaxRate,
      };

    case FETCHING_SL_GROUP_TYPES_FOR_ETR:
      return {
        ...state,
        isFetchingGroupTypes: true,
      };

    case FETCHING_SL_GROUP_TYPES_FOR_ETR_SUCCESS:
      return {
        ...state,
        isFetchingGroupTypes: false,
        groupTypes: action.groupTypes,
        groupByOptions: action.groupByOptions,
      };

    case FETCHING_SL_GROUP_TYPES_FOR_ETR_FAILURE:
      return {
        ...state,
        isFetchingGroupTypes: false,
      };

    case FETCHING_COUNTRY_TAX_TYPES_AND_RATES:
      return {
        ...state,
        isFetchingCountryTaxTypes: true,
      };

    case FETCHING_COUNTRY_TAX_TYPES_AND_RATES_SUCCESS:
      return {
        ...state,
        isFetchingCountryTaxTypes: false,
        allCountryTaxTypesAndRates: action.countryTaxTypesAndRates,
        countryTaxTypesETR: action.countryTaxTypesETR,
      };

    case FETCHING_COUNTRY_TAX_TYPES_AND_RATES_FAILURE:
      return {
        ...state,
        isFetchingCountryTaxTypes: false,
      };

    case RESET_COUNTRY_TAX_TYPES_AND_RATES:
      return {
        ...state,
        allCountryTaxTypesAndRates: initialState.allCountryTaxTypesAndRates,
        selectedCountryTaxTypes: initialState.selectedCountryTaxTypes,
        statutoryTaxRate: initialState.statutoryTaxRate,
      };

    case SAVING_CUSTOM_ETR_DRIVER:
      return {
        ...state,
        isSavingData: true,
      };

    case SAVING_CUSTOM_ETR_DRIVER_FAILURE:
      return {
        ...state,
        isSavingData: false,
      };

    case SAVING_CUSTOM_ETR_DRIVER_SUCCESS:
      return {
        ...state,
        isSavingData: false,
      };

    case FETCHING_ETR_REPORT_DATA:
      return {
        ...state,
        isFetchingReportData: true,
      };

    case FETCHING_ETR_REPORT_DATA_SUCCESS:
      return {
        ...state,
        isFetchingReportData: false,
        reportData: prepareETRReport(action.reportData),
        companyCodes: action.companyCodes,
        ETRGroups: action.ETRGroups,
      };

    case FETCHING_ETR_REPORT_DATA_FAILURE:
      return {
        ...state,
        isFetchingReportData: false,
      };

    case RESET_ETR_REPORT:
      return {
        ...state,
        reportData: initialState.reportData,
      };

    case ETR_TOGGLE_VISIBILITY: {
      const lens = lensPath(action.path);
      const groupToToggle = view(lens, state.reportData);
      const visibility = groupToToggle.isOpen;

      const toggledGroup = visibility && groupToToggle.subrows
        ? prepareTagsGroups(groupToToggle)
        : {
          ...groupToToggle,
          isOpen: !visibility,
        };

      return {
        ...state,
        reportData: set(lens, toggledGroup, state.reportData),
      };
    }

    case SELECT_EFFECTIVE_TAX_RATE_CELL_FOR_DETAILS:
      return {
        ...state,
        selectedCell: action.selectedCell,
      };

    case FETCHING_COUNTRY_TAX_TYPES_FOR_COMPANY_CODE_SUCCESS:
      return {
        ...state,
        countryTaxTypesForCompanyCode: action.countryTaxTypes,
      };

    case RESET_COUNTRY_TAX_TYPES_FOR_COMPANY_CODE:
      return {
        ...state,
        countryTaxTypesForCompanyCode: initialState.countryTaxTypesForCompanyCode,
      };

    default:
      return state;
  }
}
